import axios from "axios";
import { API_BASE_URL, LOCAL_API_URL } from "../../config";

/**
 * Create and configure Axios instance for API calls
 */
const apiClient = axios.create({
	baseURL: API_BASE_URL,
	headers: {
		"Content-Type": "application/json",
	},
});

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
	(config) => {
		const user = JSON.parse(localStorage.getItem("user"));
		if (user && user.token) {
			config.headers["Authorization"] = `Bearer ${user.token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		// Handle common errors (401, 403, etc.)
		if (error.response) {
			if (error.response.status === 401) {
				// Handle unauthorized - redirect to login or refresh token
				localStorage.removeItem("user");
				window.location.href = "/login";
			}
		}
		return Promise.reject(error);
	}
);

export default apiClient;
